import { GiftCardModel } from './gift-card.model'

export enum GiftCardJournalAction {
  GiftCardCreation = 'GiftCardCreation',
  GiftCardCancellation = 'GiftCardCancellation',
  GiftCardRedeem = 'GiftCardRedeem',
  GiftCardStatusChanged = 'GiftCardStatusChanged',
  GiftCardPaymentChanged = 'GiftCardPaymentStatusChanged',
  GiftCardStaffCommentChanged = 'GiftCardStaffCommentChanged',
  PaymentRequested = 'PaymentRequested',
  PaymentConfirmed = 'PaymentConfirmed',
  PaymentRejected = 'PaymentRejected'
}

export enum GiftCardJournalActionInitiator {
  Auto = 'Auto',
  Site = 'Site',
  Backoffice = 'Backoffice'
}

export type GiftCardJournalItem = {
  id: string | number
  dateTime: number
  actionType: GiftCardJournalAction
  giftCard: GiftCardModel
  actionInitiator: GiftCardJournalActionInitiator
  force?: boolean
  user?: {
    id: number
    firstName: string
    lastName: string
    email: string
  }
  paymentInfo?: {
    id: string | number
    link: string
    amount: number
  }
}
